import type { ApiError } from '@approvalmax/types';
import { routerHelpers } from '@approvalmax/utils';
import { useQuery } from '@tanstack/react-query';
import { hooks as pageHooks } from 'modules/page';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { api } from 'services/api';

import { showPasswordResetFinalStepModule } from '../actions';
import { QueryKeys, RESET_PASSWORD_FINAL_STEP_PAGE_ID } from '../config';

const useResetPasswordFinalStepPageData = () => {
    const dispatch = useDispatch();
    const search = useLocation().search;
    const postAction = routerHelpers.getParamAsString(search, 'postAction', '');
    const linkCode = routerHelpers.getParamAsString(search, 'linkCode', '');

    const { data, isInitialLoading, error } = useQuery<
        Awaited<ReturnType<typeof api.profile.startResetPassword>>,
        ApiError
    >([QueryKeys.ResetPasswordFinalStep, linkCode], async () => {
        return api.profile.startResetPassword({
            linkCode,
        });
    });

    useEffect(() => {
        if (data) {
            dispatch(
                showPasswordResetFinalStepModule({
                    stateId: data.StateId,
                    tfaEnabled: data.RequiresTFA,
                    postAction: postAction,
                    innerPageId: RESET_PASSWORD_FINAL_STEP_PAGE_ID,
                    isTFAAlternativeEmailEnabled: Boolean(data.IsTFAAlternativeEmailEnabled),
                    isTFABackupCodesEnabled: Boolean(data.IsTFABackupCodesEnabled),
                })
            );
        }
    }, [data, dispatch, postAction]);

    pageHooks.usePageError(error);

    return {
        isInitialLoading,
    };
};

export default useResetPasswordFinalStepPageData;
